import { FilterType } from '@/models';
import { FilterState } from '@/types/filter';
import { isRecord } from '@/utils/filter/isRecord';

const FILTER_TYPE_VALUES: ReadonlySet<string> = new Set(Object.values(FilterType));

/**
 * Checks whether a value looks like a FilterState object.
 *
 * Uses a "some known keys" heuristic instead of requiring every key to be a
 * known FilterType. Saved filters may contain legacy or future keys (e.g.
 * "classification" vs the canonical "classificationLevels") that would cause
 * a strict every-key check to fail, making the caller fall back to treating
 * the entire structured payload as a flat filter state — which surfaces the
 * raw JSON in the filter bar chip.
 */
export const isFilterState = (value: unknown): value is FilterState => {
  if (!isRecord(value)) return false;
  const keys = Object.keys(value);
  if (keys.length === 0) return true;
  return keys.some(key => FILTER_TYPE_VALUES.has(key));
};
